<template>
    <div class="tour-date-selector">
      <div class="tour-date-selector__left" @click="$emit('showSelectorPopup')" >
        <Icon
          icon="search"
          class="tour-date-selector__icon-search"
          color="#121212"
        />
        <div class="tour-date-selector__body">
          <div class="tour-date-selector__location">{{ getTypeText }}, {{getDirectionText }}</div>
          <div class="tour-date-selector__date">
            {{getDatesText}}
          </div>
        </div>
      </div>
      <div class="tour-date-selector__icon-close" @click="$emit('clearSearch')">
        <Icon
          v-if="showCloseBtn"
          icon="close"
          color="#9999A9"
        />
      </div>
    </div>
</template>

<script>
import Icon from "@/components/icons/index.vue";
import getFormattedDateRange from "@/assets/js/utils/get-formatted-date-range"
import { i18n } from "@/plugins/i18n";

import {mapMutations, mapState} from "vuex";
import {parse} from "date-fns";
export default {
  name: "tour-date-selector",
  components: {
    Icon,
  },
  data() {
    return {
      isPopupOpen: false
    }
  },
  computed: {
    ...mapState({
      productType: (state) => state.serp.productType,
      dates: (state) => state.serp.dates,
      location: (state) => state.serp.location,
    }),
    getTypeText(){
      let text = "";
      switch (this.productType) {
        case "multiDays": text = this.$t("serp.topMenu.manyDays"); break;
        case "oneDay":   text = this.$t("serp.topMenu.oneDay");   break;
        case "exclusive": text = this.$t("serp.topMenu.unusual");  break;
      }
      return text;
    },
    getDirectionText() {
      return this.location ? this.location[0].label : this.$t("serp.topMenu.allDirections");
    },
    getDatesText() {
      let dateRange = !this.dates ? this.dates : this.dates[0];
      if(this.dates) {
        const [startValue, endValue] = dateRange;
        let startDate = this.isValidDate(startValue)
          ? startValue
          : parse(startValue, "dd.MM.yyyy", new Date())
        let endDate =  this.isValidDate(endValue)
          ? endValue
          : parse(endValue, "dd.MM.yyyy", new Date())
        return getFormattedDateRange(startDate,endDate, i18n.locale)+" "+endDate.getFullYear();
      }
      return this.$t("serp.topMenu.allDates");
    },
    showCloseBtn() {
      return this.location || this.dates
    }
  },
  methods: {
    ...mapMutations({
      selectDates: "serp/selectDates",
      selectLocation: "serp/selectLocation",
    }),
    isValidDate(date) {
      return date instanceof Date && !isNaN(date);
    },
    openSelectorPopup(){
      this.isPopupOpen = true;
    },
    closePopup(){
      this.isPopupOpen = false;
    },
  },
}
</script>
<style lang="scss" scoped>
.tour-date-selector{
  background: #EEEEF2;
  border-radius: 12px;
  display: flex;
  align-items: center;
  padding: 8px 12px;
  position: relative;

  &__left{
    display: flex;
    align-items: center;
    width: 100%;
    margin-right: 30px;
  }
  &__body{
    margin: 0 0 0 13px;
    min-height: 35px;
  }
  &__location{
    color: #121212;
    font-size: 13px;
    font-weight: 600;
    line-height: 17px;
  }
  &__date{
    color: #828296;
    font-size: 13px;
  }
  &__icon-close{
    width: 40px;
    height: 100%;
    position: absolute;
    right: 0;
    top: 0;
    display: flex;
    align-items: center;
    justify-content: center;
  }
}
</style>
